import { Injectable } from '@angular/core';
import {BASE_URL, FamilyVM, blobFamilyImageVM, FamilyDetailsVM, UserVM} from './setup-family.model'
import { Http,Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { HttpClientModule } from '@angular/common/http'; 
import { HttpModule } from '@angular/http'
import { catchError } from 'rxjs/operators';

@Injectable()
export class SetupFamilyService {

  availableFamilyList: FamilyDetailsVM[];
  avaiableFamilyImageList :blobFamilyImageVM[]
  userId:string
  constructor(
    private _http: Http
  ) { }


  public getFamilyList() {
    this._http.get(`${BASE_URL}/getAllFamilyList`)
      .map((data: Response) => {
        return data.json() as FamilyDetailsVM[];
      }).toPromise().then(x => {
        this.availableFamilyList = x;
      })
  }

  public getFamilyImageList() {
    this._http.get(`${BASE_URL}/getAllFamilyBlobImageList`)
      .map((data: Response) => {
        return data.json() as blobFamilyImageVM[];
      }).toPromise().then(x => {
        this.avaiableFamilyImageList = x;
      })
  }
 
  public savefamilyDetails( type_auto :number,
    typeid :string,
    typedesc :string,
    createdUser :string,
    blob_auto :number,
    ChainImage:string,
    FrameImage: string,
    ShowDistTravelledTracking: boolean,
    ShowPropelHrsPerc: boolean,
    ShowEqualiserBarType: boolean,
    ShowTrackIntensionIndicator: boolean,
    ShowFrameConfiguration: boolean,
    showCannonType: boolean,
    showBogieShim: boolean,
    showManualInspection: boolean,
    showTrackSag: boolean,
    showCannonExt: boolean,
    showScallop: boolean,
    showDryJoints: boolean,
    showNumberOfLinks: boolean,
    showUnderFootConditions: boolean,
    showWorkOrder: boolean,
    showThermalImage: boolean,
    showAdditionalInspectors: boolean,
    isConditon: boolean,
    showIsometricViews: boolean
  ): Observable<FamilyDetailsVM[]> {

    let obj = {
      'type_auto': type_auto,
      'typeid': typeid,
      'typedesc': typedesc,
      'createdUser': createdUser,
      'blob_auto': blob_auto,
      'ChainImage': ChainImage,
      'FrameImage': FrameImage,
      'ShowDistTravelledTracking': ShowDistTravelledTracking,
      'ShowPropelHrsPerc': ShowPropelHrsPerc,
      'ShowEqualiserBarType': ShowEqualiserBarType,
      'ShowTrackIntensionIndicator': ShowTrackIntensionIndicator,
      'ShowFrameConfiguration': ShowFrameConfiguration,
      'ShowCannonType': showCannonType,
      'ShowBogieShim': showBogieShim,
      'ShowManualInspection': showManualInspection,
      'ShowTrackSag': showTrackSag,
      'ShowCannonExt': showCannonExt,
      'ShowScallop': showScallop,
      'ShowDryJoints': showDryJoints,
      'ShowNumberOfLinks': showNumberOfLinks,
      'ShowUnderFootConditions': showUnderFootConditions,
      'ShowWorkOrder': showWorkOrder,
      'ShowThermalImage': showThermalImage,
      'ShowAdditionalInspectors': showAdditionalInspectors,
      'IsConditon': isConditon,
      'ShowIsometricViews': showIsometricViews
    };
    return this._http
      .post(`${BASE_URL}/SaveUpdateFamilyDetails`, obj).map((data: Response) => {
        return data.json();
      }).pipe(catchError(this.handleError));
  }

  public deletfamilyDetails( type_auto :number): Observable<FamilyDetailsVM[]> {
    let obj = {
      'type_auto': type_auto
    };
    return this._http
      .post(`${BASE_URL}/DeleteFamilyDetails`, obj).map((data: Response) => {
        return data.json();
      }).pipe(catchError(this.handleError));
  }



public getUsername() {
  this._http.get('Api/User/GetLoggedInUserName')
    .map((data: Response) => {
      return data.json();
    }).toPromise().then(x => {
      this.userId = x;
    })
}
  private handleError(error: Response) {
    return Observable.throw(error || 'Server error');
  }
}

